import { useContext } from 'react';
import {
  SentenceSetContext,
  SentenceState,
} from '@/contexts/SentenceSetContext/entry';

export function useSentenceSetContext() {
  const {
    data,
    selectedData,
    limitModal,
    sentenceSubTypes,
    term,
    termType,
    sentenceType,
    searchSentencesPerPage,
    page,
    handleOuterState,
    handleArrayState,
    handleSentenceTypeState,
    handleSubjectTypeState,
    subjectType,
    changeData,
    changeSelectedData,
    changeLimitModal,
    refetchSentences,
    patientId,
    setId,
    apiName,
    changePage,
    editData,
    tags,
    scrollViewRef,
    template,
  } = useContext<SentenceState>(SentenceSetContext);
  return {
    data,
    selectedData,
    editData,
    limitModal,
    sentenceSubTypes,
    term,
    termType,
    sentenceType,
    searchSentencesPerPage,
    page,
    handleOuterState,
    handleArrayState,
    handleSentenceTypeState,
    handleSubjectTypeState,
    subjectType,
    changeData,
    changeSelectedData,
    changeLimitModal,
    refetchSentences,
    changePage,
    dataKeyName: 'sentences' as const,
    apiKeyName: 'sentencesets' as const,
    dynamicName: 'sentenceset' as const,
    patientId,
    setId,
    apiName,
    tags,
    scrollViewRef,
    template,
  };
}
